import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../helper/firebaseClient";
import { useDepartment } from "../../stores/departmentStore";
// import { list } from "firebase/storage";

export default function DepartmentLoader() {
  console.log(useDepartment());
  const setDepartments = useDepartment((state) => state.setDepartments);
  const listDepartments = useDepartment((state) => state.listDepartments);
  // listDepartments();
  // console.log("Callse");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setDepartments([]);
        return;
      }

      // 🔹 Load departments ONLY after valid login
      await listDepartments();
    });

    return () => {
      unsub();
      // setDepartments([]);
    };
  }, [listDepartments, setDepartments]);

  return null;


  // useEffect(() => {
  //   onAuthStateChanged(auth, (user) => {
  //     if (user) {
  //       listDepartments();
  //     }
  //   });

  //   return () => {
  //     setDepartments([]);
  //   };
  // }, [auth.currentUser]);

  // return <div></div>;
}
